@if (!isLg()) {
  <shell-navbar class="navbar" />
}

<!--<div class="xmas-decoration"></div>-->

<div class="wrapper" [ngClass]="wrapperState.classList()" [class.wrapper_stretch]="settingsState.isStretchDesign()">
  <div class="main">
    <div class="main-top_content">
      <shell-header class="header" [class.is-hidden]="isLg() && wrapperState.isShopOpen()" />

      <div class="container">
        <router-outlet />
      </div>
    </div>

    <shell-footer [isStretch]="wrapperState.isStretchFooter()" [gameModule]="wrapperState.gameModule()" />
  </div>
</div>

@defer (on immediate) {
  <chat-sidebar class="chat-sidebar" />
}

@if (isLg()) {
  @defer (on immediate) {
    @if (!isCrashPage() && !isSuperWheelPage()) {
      <ui-sticky-bet />
    }
    <shell-handheld-toolbar [class.is-hidden]="isLg() && wrapperState.isShopOpen()" />
  }
}

@if (authState.isAuthenticated() && !authState.user()!.isTosRead) {
  @defer (on immediate) {
    <shell-tos-overlay class="tos-overlay" />
  }
}

@if (showWebPushesPrompt()) {
  @defer (on immediate) {
    <web-pushes-prompt class="web-pushes-prompt" (closed)="onPromptClosed()" />
  }
}
